<template>
    <div class="">
        <div class="">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <ol class="breadcrumb fs-sm mb-1">
                        <li class="breadcrumb-item active"><router-link to="/dashboard">Dashboard</router-link></li>
                    </ol>
                    <label class="form-label"> <h4>User Wise Dashboard</h4></label>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="me-3">
                        <select class="form-control" v-model="time_period" @change="onChange">
                            <option value="1">All</option>
                            <option value="2">Today</option>
                            <option value="3">Yesterday</option>
                            <option value="4">Week</option>
                            <option value="5">Custom</option>
                        </select>
                    </div>
                    <div class="me-3">
                        <flatPickr class="form-control flatpickr_date" placeholder="Select Date Range" ref="flatpickr" :config="config" @onChange="getSelectedDates" style="width: 200px;"> </flatPickr>
                    </div>
                    <div class="me-3">
                        <Search
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data=" users"
                            @input=" user => meta.user_id = user"
                            @selectsearch="index()"
                        >
                        </Search>
                    </div>
                    <!-- <a type="button" class="text-danger me-2" @click="reset()"><i class="ri-close-line fs-20 lh-2"></i></a> -->
                    <button type="button" @click="reset()" class="btn btn-danger btn-sm"><i class="ri-close-line lh-1"></i></button>
                </div>
            </div>
            <div class="">
                <div class="row g-3 mb-3">
                    <div class="col-3">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-creative-commons-by-fill"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24">{{ school_visited }}</h1>
                                <label class="d-block mb-1 fw-medium text-dark">Total School Visited</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-account-circle-line"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24">{{ kg_student_count }}</h1>
                                <label class="d-block mb-1 fw-medium text-dark">Total Kg Student</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-government-line"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24">{{ school_visited_date_time }}</h1>
                                <label class="d-block mb-1 fw-medium text-dark">School Visited {{ custome_date_time }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-team-fill"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24">{{ kg_student_date_time }}</h1>
                                <label class="d-block mb-1 fw-medium text-dark">Kg Strength {{ custome_date_time }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3" v-for="dynamic_stages, key in Dynamicstages" :key="key">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-group-2-line"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24">{{ dynamic_stages.visit_count }} / {{ dynamic_stages.kg_count }}</h1>
                                <label class="d-block mb-1 fw-medium text-dark">{{dynamic_stages.name}} / Kg Strength</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card card-one br-16">
                            <div class="card-body p-3">
                                <div class="d-block fs-30 lh-1 text-primary mb-3"><i class="ri-calendar-todo-line"></i></div>
                                <h1 class="card-value mb-0 ls--1 fs-24"><router-link :to="{ path: '/reminders', query: { from: 'dashboard' } }" class="">{{ reminders_count }}</router-link></h1>
                                <label class="d-block mb-1 fw-medium text-dark">Total Reminders {{ custome_date_time }}</label>
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-1">
                    <!-- <div class="col-md-3 mb-2">
                        <div class="card">
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">Total School Visited</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>{{ school_visited }}</p>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-2">
                        <div class="card" >
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">Total Kg Student</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>{{ kg_student_count }}</p>
                                </strong>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-2">
                        <div class="card" >
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">School Visited {{ custome_date_time }}</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>{{ school_visited_date_time }}</p>
                                </strong>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-2">
                        <div class="card" >
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">Kg Strength {{ custome_date_time }}</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>{{ kg_student_date_time }}</p>
                                </strong>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-2" v-for="dynamic_stages, key in Dynamicstages" :key="key">
                        <div class="card" >
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">{{dynamic_stages.name}} / Kg Strength</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>{{ dynamic_stages.visit_count }} / {{ dynamic_stages.kg_count }}</p>
                                </strong>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 mb-2">
                        <div class="card" >
                            <div class="card-header card1" style="justify-content: center;">
                                <strong>
                                    <label class="form-label label_font">Total Reminders {{ custome_date_time }}</label>
                                </strong>
                            </div>
                            <div class="card-body" style="text-align: center;">
                                <strong>
                                    <p>
                                        <router-link to="/reminders" class="nav-label single-label">{{ reminders_count }}</router-link>
                                    </p>
                                </strong>

                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-12">
                        <label class="form-label"> <h4>Visit Counts (Stage Wise)</h4></label>
                        <!-- <strong>
                                    <label class="form-label">Visit Counts (Stage Wise)</label>
                                </strong> -->
                        <div class="card br-16 card-shadow">
                            <!-- <div class="card-header card1">
                                <strong>
                                    <label class="form-label">Visit Counts (Stage Wise)</label>
                                </strong>
                            </div> -->
                            <div class="card-body">
                                <div class="" style="height: 205px; overflow-x: hidden; overflow-y: scroll;">
                                    <div class="table-responsive table-responsive-sm">
                                        <table class="table table-sm bg-white text-nowrap table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">Sl.No</th>
                                                    <th>Stage</th>
                                                    <th>Visit Count</th>
                                                    <th>KG Count</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="visit_count.length == 0">
                                                    <td colspan="4" class="text-center">No records found</td>
                                                </tr>
                                                <tr v-for="(visit, key) in visit_count" :key="key">
                                                    <td class="text-center">{{ key + 1 }}</td>
                                                    <td>{{ visit?.name }}</td>
                                                    <td>{{ visit?.visit_count }}</td>
                                                    <td>{{ visit?.kg_count }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Search from "@/components/Search.vue";
    // import moment from 'moment-timezone';
    import moment from "moment";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { getFinancialYearDateRange } from "@/utils/dateRange";
    export default {
        name: "Dashboard",
        components: { Search, flatPickr },
        data() {
            return {
                meta: {
                    user_id: "",
                    from_date_time: "",
                    to_date_time: "",
                },
                time_period: 1,
                users: [],
                school_visited: "",
                kg_student_count: "",
                school_visited_date_time: "",
                kg_student_date_time: "",
                // PO_stages_count: '',
                // PO_kg_count: '',
                Dynamicstages: [],
                reminders_count: "",
                visit_count: [],
                errors: [],
                config: {
                    mode: "range",
                    defaultDate: [],
                    dateFormat: "d-m-Y",
                },
                custome_date_time: "",
                dashboardRequestId: 0,
                dashboardFetchInFlight: false,
                dashboardLastPayloadKey: "",
            };
        },
        mounted() {
            this.getUsers();
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // console.log(from);
                if (from.name == "login") {
                    vm.$router.go();
                }
            });
        },

        // watch:{
        //     'meta.user_id': function () {
        //         this.$store.commit("setReminderSearch", this.meta)
        //     },
        //     'meta.from_date_time': function () {
        //         this.$store.commit("setReminderSearch", this.meta)
        //     },
        //     'meta.to_date_time': function () {
        //         this.$store.commit("setReminderSearch", this.meta)
        //     },
        // },
        methods: {
            getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "users/getUsers" })
                    .then((response) => {
                        loader.hide();
                        vm.users = response.data.data;
                        vm.applyFinancialYearDefault();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            formatDateTimeForApi(date_time) {
                const parsed = moment(date_time, ["DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD HH:mm:ss"], true);
                return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm:ss") : "";
            },
            buildApiPayload() {
                const payload = {
                    user_id: this.meta.user_id,
                    from_date_time: "",
                    to_date_time: "",
                };

                if (this.meta.from_date_time && this.meta.to_date_time) {
                    payload.from_date_time = this.formatDateTimeForApi(this.meta.from_date_time);
                    payload.to_date_time = this.formatDateTimeForApi(this.meta.to_date_time);
                }

                return payload;
            },
            index() {
                let vm = this;
                const payload = vm.buildApiPayload();
                const payloadKey = JSON.stringify(payload);

                if (vm.dashboardFetchInFlight && vm.dashboardLastPayloadKey === payloadKey) {
                    return;
                }

                vm.dashboardLastPayloadKey = payloadKey;
                vm.dashboardFetchInFlight = true;
                const requestId = ++vm.dashboardRequestId;
                const loader = vm.$loading.show();

                vm.$store.commit("setReminderSearch", { ...vm.meta });
                vm.$store
                    .dispatch("post", { uri: "dashboard/dashboardDetails", data: payload })
                    .then((response) => {
                        if (requestId !== vm.dashboardRequestId) {
                            return;
                        }
                        vm.school_visited = response?.data?.data?.school_visit_count;
                        vm.kg_student_count = response?.data?.data?.totalKgStrength;
                        vm.school_visited_date_time = response?.data?.data?.schoolsWithDateTime;
                        vm.kg_student_date_time = response?.data?.data?.totalKgStrengthDateTime;
                        // vm.PO_stages_count = response?.data?.data?.PO_stages_count;
                        // vm.PO_kg_count = response?.data?.data?.PO_kg_count;
                        vm.Dynamicstages = response?.data?.data?.Dynamicstages;
                        vm.reminders_count = response?.data?.data?.reminders_count;
                        vm.visit_count = response?.data?.data?.stages;
                    })
                    .catch(function (error) {
                        if (requestId !== vm.dashboardRequestId) {
                            return;
                        }
                        vm.errors = error.response?.data?.errors;
                        vm.$store.dispatch("error", error.response?.data?.message);
                    })
                    .finally(function () {
                        loader.hide();
                        if (requestId === vm.dashboardRequestId) {
                            vm.dashboardFetchInFlight = false;
                        }
                    });
            },

            reset() {
                this.meta.user_id = "";
                this.time_period = 1;
                this.onChange();
            },

            applyFinancialYearDefault() {
                let vm = this;
                const { from, to, label } = getFinancialYearDateRange();
                vm.meta.from_date_time = from;
                vm.meta.to_date_time = to;
                vm.custome_date_time = label;
                if (vm.$refs.flatpickr) {
                    vm.$refs.flatpickr.fp.setDate([from, to]);
                }
                vm.setFlatpickrPresetStyle(true);
                vm.index();
            },

            setFlatpickrPresetStyle(isPreset) {
                const calendar = document.getElementsByClassName("flatpickr-calendar")[0];
                const dateInput = document.getElementsByClassName("flatpickr_date")[0];
                if (calendar) {
                    calendar.style.display = isPreset ? "none" : "block";
                }
                if (dateInput) {
                    dateInput.style.backgroundColor = isPreset ? "#f5f5f5" : "#ffffff";
                }
            },

            onChange() {
                let vm = this;
                const fromdate = moment();
                const todate = moment();
                if (vm.time_period == 1) {
                    vm.custome_date_time = "";
                    vm.meta.from_date_time = "";
                    vm.meta.to_date_time = "";
                    if (this.$refs.flatpickr) {
                        this.$refs.flatpickr.fp.setDate([vm.meta.from_date_time, vm.meta.to_date_time]);
                    }
                    vm.setFlatpickrPresetStyle(true);
                }
                if (vm.time_period == 2) {
                    vm.meta.from_date_time = fromdate.format("DD-MM-YYYY 00:00:00");
                    vm.meta.to_date_time = todate.format("DD-MM-YYYY 23:59:59");
                    if (this.$refs.flatpickr) {
                        this.$refs.flatpickr.fp.setDate([vm.meta.from_date_time, vm.meta.to_date_time]);
                    }
                    vm.custome_date_time = "Today";
                    vm.setFlatpickrPresetStyle(true);
                }
                if (vm.time_period == 3) {
                    vm.meta.from_date_time = fromdate.subtract(1, "days").format("DD-MM-YYYY 00:00:00");
                    vm.meta.to_date_time = todate.subtract(1, "days").format("DD-MM-YYYY 23:59:59");
                    if (this.$refs.flatpickr) {
                        this.$refs.flatpickr.fp.setDate([vm.meta.from_date_time, vm.meta.to_date_time]);
                    }
                    vm.custome_date_time = "Yesterday";
                    vm.setFlatpickrPresetStyle(true);
                }
                if (vm.time_period == 4) {
                    vm.meta.from_date_time = fromdate.subtract(7, "days").format("DD-MM-YYYY 00:00:00");
                    vm.meta.to_date_time = todate.format("DD-MM-YYYY 23:59:59");
                    if (this.$refs.flatpickr) {
                        this.$refs.flatpickr.fp.setDate([vm.meta.from_date_time, vm.meta.to_date_time]);
                    }
                    vm.custome_date_time = "Week";
                    vm.setFlatpickrPresetStyle(true);
                }
                if (vm.time_period == 5) {
                    vm.custome_date_time = "";
                    vm.setFlatpickrPresetStyle(false);
                }
                vm.index();
            },
            getSelectedDates(dates) {
                let vm = this;
                if (!dates || dates.length < 2 || !dates[0] || !dates[1]) {
                    return;
                }

                const from_date_time = moment(dates[0]).format("DD-MM-YYYY 00:00:00");
                const to_date_time = moment(dates[1]).format("DD-MM-YYYY 23:59:59");

                if (
                    from_date_time === vm.meta.from_date_time &&
                    to_date_time === vm.meta.to_date_time
                ) {
                    return;
                }

                vm.time_period = 5;
                vm.meta.from_date_time = from_date_time;
                vm.meta.to_date_time = to_date_time;
                vm.custome_date_time = "";
                vm.setFlatpickrPresetStyle(false);
                vm.index();
            },
        },
    };
</script>

<style scoped>
    table th,
    table td {
        padding: 6px 10px;
        border: 1px solid #dee2e6; /* Border for table cells */
    }
    .label_font {
        font-size: 11px;
    }
</style>
